import { createSlice } from "@reduxjs/toolkit";

const radioData = {
  data: {
    "wireless.radio": [
      {
        "band": "2",
        "chanWidth": "Auto",
        "channel": "1,2,3",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "7b7efa33-84ab-4006-a01e-b4908bb09758",
        "pscChannels": null,
        "rssiThreshold": 10,
        "rssiThresholdEnable": false,
        "txPower": 50,
        "version": 1,
        "wirelessMode": "Auto",
        "dtimInterval": 1,
        "shortGi": true,
        "igmpSnooping": true,
        "multicastBandwidthControl": true,
        "maxMulticastBandwidth": 1,
        "broadcastToUnicast": true,
        "rtsLength": 256,
        "fragmentLength": 256,
        "connectionLimit": true,
        "userLimit": 0,
        "preferred11n": true,
        "networkUtilization": 0,
      },
      {
        "band": "5",
        "chanWidth": "20",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "9280b891-1a41-4023-8d5d-9792a7de32c8",
        "pscChannels": null,
        "rssiThreshold": 50,
        "rssiThresholdEnable": false,
        "txPower": 100,
        "version": 1,
        "wirelessMode": "Auto",
        "dtimInterval": 1,
        "shortGi": true,
        "igmpSnooping": true,
        "multicastBandwidthControl": true,
        "maxMulticastBandwidth": 1,
        "broadcastToUnicast": true,
        "rtsLength": 256,
        "fragmentLength": 256,
        "connectionLimit": true,
        "userLimit": 0,
        "preferred11n": true,
        "networkUtilization": 0,
      },
      {
        "band": "6",
        "chanWidth": "160",
        "channel": "Auto",
        "dfsChannels": true,
        "h2040Coexistence": null,
        "id": "ffc52d84-3591-4d04-873e-a5cebc51957e",
        "pscChannels": null,
        "rssiThreshold": 100,
        "rssiThresholdEnable": false,
        "txPower": 12,
        "version": 1,
        "wirelessMode": "Auto",
        "dtimInterval": 1,
        "shortGi": true,
        "igmpSnooping": true,
        "multicastBandwidthControl": true,
        "maxMulticastBandwidth": 1,
        "broadcastToUnicast": true,
        "rtsLength": 256,
        "fragmentLength": 256,
        "connectionLimit": true,
        "userLimit": 0,
        "preferred11n": true,
        "networkUtilization": 0,
      }
    ],
    "wireless.radioGlobal": {
      "id": "f9f51570-9f2c-4bd6-b830-7e5bd8e7aba4",
      "neighborApDetection": false,
      "neighborApDetectionSchedule": ["01:30", "05:00"],
      "version": 1,
      "airtimeFairness": true,
      "bandSteering": true,
      "autoFailover": true,
      "smartWifi": true,
      "autoChannelAdjustment": true,
      "autoPowerAdjustment": true,
      "autoPowerSchedule": ["00:30", "03:00"],
    }
  }
};

export const radioSlice = createSlice({
  name: "radio",
  initialState: radioData,
  reducers: {
    setRadioData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setRadioData } = radioSlice.actions;

export default radioSlice.reducer;
